import { GeoblockErrorScreenTemplate } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { model as i18n } from '~/core/i18n'
import { AuthLayout } from '~/widgets/auth'

GeoBlockPage.displayName = 'GeoBlockPage'

export function GeoBlockPage(): JSX.Element {
  const { t } = useUnit(i18n.$t)

  return (
    <AuthLayout>
      <GeoblockErrorScreenTemplate
        title={t('sorry')}
        description={t('geo_block_log_in_error')}
      />
    </AuthLayout>
  )
}
